import React, { ReactNode } from "react";
import { Image, VStack } from "@chakra-ui/react";

import not_found from "assets/not_found.svg";

import { NotificationPrototype } from "./components/NotificationPrototype";

import { ChakraText } from "../ChakraText";

interface IProps {
  children?: ReactNode;
}

const NotFoundNotification = ({
  children = <ChakraText fontSize="3xl">Nie znaleziono strony</ChakraText>,
}: IProps) => {
  return (
    <NotificationPrototype>
      <VStack spacing={6}>
        <Image maxH="400px" src={not_found} alt="Ostrzeżenie" />
        {children}
      </VStack>
    </NotificationPrototype>
  );
};

export { NotFoundNotification };
